<template>
  <div class="ind-bk">
    <div class="rou-div">
      <router-link
        class="puc-rou hvr-wobble-vertical"
        id="trend"
        :to="{ name: 'trend', query: { id: 0 } }"
      ></router-link>
      <router-link
       class="puc-rou hvr-wobble-vertical"
        id="performance"
        :to="{ name: 'performance', query: { id: 1 } }"
      ></router-link>
      <router-link
       class="puc-rou hvr-wobble-vertical"
        id="appear"
        :to="{ name: 'appear', query: { id: 2 } }"
      ></router-link>
      <router-link
       class="puc-rou hvr-wobble-vertical"
        id="product"
        :to="{ name: 'product', query: { id: 3 } }"
      ></router-link>
      <router-link
       class="puc-rou hvr-wobble-vertical"
        id="scheme"
        :to="{ name: 'scheme', query: { id: 4 } }"
      ></router-link>
      <router-link
       class="puc-rou hvr-wobble-vertical"
        id="strategy"
        :to="{ name: 'strategy', query: { id: 5 } }"
      ></router-link>
    </div>
    <div class="put">
      <p>备案号：<a href="https://beian.miit.gov.cn/">粤ICP备09063021号-1 </a> &nbsp;&nbsp;   电信增值业务经营许可证：粤B2-20100259  &nbsp;&nbsp;   服务电话：0755-23947175  &nbsp;&nbsp;   服务微信：CPSZAW  </p>
       <div class="page-view">阅读人次: <span>{{pv}}</span></div>
    </div>
  </div>
</template>


<script>
import { pdhits } from "../api/api";

export default {
  data() {
    return {
      pv: 0,
    };
  },
  methods: {
    //获取数据
    getData: function () {
      var gain = {
        code: "pc",
      };
      pdhits(gain).then((res) => {
        this.pv = res.data.hits;
        
      });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style >
.ind-bk {
  width: 100%;
  height: 100%;
  background-image: url(../assets/img/index-back.jpg);
  background-repeat: no-repeat;
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  min-width: 1200px;
  z-index: -10;
  zoom: 1;
  background-color: #fff;
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center 0;
}
.rou-div {
  position: fixed;
  bottom: 160px;
  margin: 0 auto;
  text-align: center;
  left: 0;
  right: 0;
}
.rou-div .puc-rou{
   display: inline-block;
  width: 158px;
  height: 158px;
   background-size: 158px 158px;
  margin-bottom: 1rem;
  margin: 15px 20px;
  border-radius: 50%;
}

.puc-rou:hover{
    background-color: #4cc9f0;
  -webkit-box-shadow: 10px 10px 99px 6px rgba(76,201,240,1);
  -moz-box-shadow: 10px 10px 99px 6px rgba(76,201,240,1);
  box-shadow: 10px 10px 99px 6px linear-gradient(270deg, rgba(56, 18, 178, 0.5), rgba(250, 29, 129, 0.5)) 4 4;;
  transition: all 600ms cubic-bezier(0.6, 1, 0.2, 1);
   -webkit-transition: all 600ms cubic-bezier(0.1, 1, 0.6, 1);
}
/* .puc-rou:hover:after {
  left: 120%;
} */

.rou-rou:before{
  content: '';
  display: block;
  background: linear-gradient(to left, rgba(255, 255, 255, 0) 50%, rgba(255, 255, 255, 0.4) 50%);
  background-size: 210% 100%;
  background-position: right bottom;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  bottom:0;
  right:0;
  left: 0;
  border-radius: 50px;
  transition: all 1s;
  -webkit-transition: all 1s;
}

/* Wobble Vertical */
@-webkit-keyframes hvr-wobble-vertical {
  16.65% {
    -webkit-transform: translateY(8px);
    transform: translateY(8px);
  }
  33.3% {
    -webkit-transform: translateY(-6px);
    transform: translateY(-6px);
  }
  49.95% {
    -webkit-transform: translateY(4px);
    transform: translateY(4px);
  }
  66.6% {
    -webkit-transform: translateY(-2px);
    transform: translateY(-2px);
  }
  83.25% {
    -webkit-transform: translateY(1px);
    transform: translateY(1px);
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
}
@keyframes hvr-wobble-vertical {
  16.65% {
    -webkit-transform: translateY(8px);
    transform: translateY(8px);
  }
  33.3% {
    -webkit-transform: translateY(-6px);
    transform: translateY(-6px);
  }
  49.95% {
    -webkit-transform: translateY(4px);
    transform: translateY(4px);
  }
  66.6% {
    -webkit-transform: translateY(-2px);
    transform: translateY(-2px);
  }
  83.25% {
    -webkit-transform: translateY(1px);
    transform: translateY(1px);
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
}
.hvr-wobble-vertical {
  display: inline-block;
  /* vertical-align: middle; */
  -webkit-transform: perspective(1px) translateZ(0);
  transform: perspective(1px) translateZ(0);
  box-shadow: 0 0 1px rgba(0, 0, 0, 0);
}
.hvr-wobble-vertical:hover, .hvr-wobble-vertical:focus, .hvr-wobble-vertical:active {
  -webkit-animation-name: hvr-wobble-vertical;
  animation-name: hvr-wobble-vertical;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-timing-function: ease-in-out;
  animation-timing-function: ease-in-out;
  -webkit-animation-iteration-count: 1;
  animation-iteration-count: 1;
}

#trend {
  background: url(../assets/icon/menu1.png) no-repeat;
}
#performance {
  background: url(../assets/icon/menu2.png) no-repeat;
}
#appear {
  background: url(../assets/icon/menu3.png) no-repeat;
}
#strategy {
  background: url(../assets/icon/menu6.png) no-repeat;
}
#scheme {
  background: url(../assets/icon/menu5.png) no-repeat;
}
#product {
  background: url(../assets/icon/menu4.png) no-repeat;
}

.put{
  width: 100%;
  background: rgba(0, 0, 0, 0.2);
  position: fixed;
  bottom: 0;
  padding: 10px ;
}
.put p{
  font-size: 16px;
  text-align: center;
  color: #fff;
}

.page-view{
    font-size: 14px;
    color: #fff;
  
    /* background-image: linear-gradient(to right, #FA1D80 , #3712B2);*/
    background-color: rgba(0, 0, 0, 0.4); 
    position: fixed;
    top: 15px;
    right: 20px;
    z-index: 11;
    padding: 7px 12px;
    border-radius: 30px;
  }
</style>


// WEBPACK FOOTER //
// src/components/Index.vue